<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
          <el-form-item label="账号ID" prop="advertPlatformAccountId">
          <el-input v-model="dataForm.advertPlatformAccountId" placeholder="广告平台账号id"></el-input>
      </el-form-item>
          <el-form-item label="账号名称" prop="accountName">
          <el-input v-model="dataForm.accountName" placeholder="账号名称"></el-input>
      </el-form-item>
<!--          <el-form-item label="所属广告平台" prop="advertPlatform">-->
<!--          <el-input v-model="dataForm.advertPlatform" placeholder="所属广告平台"></el-input>-->
<!--      </el-form-item>-->
<!--          <el-form-item label="授权状态" prop="status">-->
<!--          <el-input v-model="dataForm.status" placeholder="授权状态"></el-input>-->
<!--      </el-form-item>-->
<!--          <el-form-item label="access_token" prop="accessToken">-->
<!--          <el-input v-model="dataForm.accessToken" placeholder="access_token"></el-input>-->
<!--      </el-form-item>-->
<!--          <el-form-item label="refresh_token" prop="refreshToken">-->
<!--          <el-input v-model="dataForm.refreshToken" placeholder="refresh_token"></el-input>-->
<!--      </el-form-item>-->
<!--          <el-form-item label="access_token有效时间（毫秒）" prop="accessTokenExpiresIn">-->
<!--          <el-input v-model="dataForm.accessTokenExpiresIn" placeholder="access_token有效时间（毫秒）"></el-input>-->
<!--      </el-form-item>-->
<!--          <el-form-item label="refresh_token有效时间（毫秒）" prop="refreshTokenExpiresIn">-->
<!--          <el-input v-model="dataForm.refreshTokenExpiresIn" placeholder="refresh_token有效时间（毫秒）"></el-input>-->
<!--      </el-form-item>-->
<!--          <el-form-item label="access_token过期时间" prop="accessTokenExpireTime">-->
<!--          <el-input v-model="dataForm.accessTokenExpireTime" placeholder="access_token过期时间"></el-input>-->
<!--      </el-form-item>-->
<!--          <el-form-item label="refresh_token过期时间" prop="refreshTokenExpireTime">-->
<!--          <el-input v-model="dataForm.refreshTokenExpireTime" placeholder="refresh_token过期时间"></el-input>-->
<!--      </el-form-item>-->
<!--          <el-form-item label="授权返回结果" prop="authorizerInfo">-->
<!--          <el-input v-model="dataForm.authorizerInfo" placeholder="授权返回结果"></el-input>-->
<!--      </el-form-item>-->
<!--          <el-form-item label="创建人" prop="createdBy">-->
<!--          <el-input v-model="dataForm.createdBy" placeholder="创建人"></el-input>-->
<!--      </el-form-item>-->
<!--          <el-form-item label="修改人" prop="updatedBy">-->
<!--          <el-input v-model="dataForm.updatedBy" placeholder="修改人"></el-input>-->
<!--      </el-form-item>-->
<!--          <el-form-item label="创建时间" prop="createTime">-->
<!--          <el-input v-model="dataForm.createTime" placeholder="创建时间"></el-input>-->
<!--      </el-form-item>-->
<!--          <el-form-item label="修改时间" prop="updateTime">-->
<!--          <el-input v-model="dataForm.updateTime" placeholder="修改时间"></el-input>-->
<!--      </el-form-item>-->
<!--          <el-form-item label="删除时间" prop="deleteTime">-->
<!--          <el-input v-model="dataForm.deleteTime" placeholder="删除时间"></el-input>-->
<!--      </el-form-item>-->
      </el-form>
<!--      <operate-auth v-if="addOrUpdateVisible" ref="operateOauth"></operate-auth>-->
      <!--<el-dialog
              title="授权"
              :visible.sync="dialogVisibleOauth"
              top="50px"
              center="true"
              width="80%"
              modal="false">
          <iframe style="width: 100%;height: 500px;margin-top: 10px;margin-top: -10px;" :src="url"></iframe>
      </el-dialog>-->
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
// import OperateAuth from './advertoauth-operate'
export default {
  data () {
    return {
      visible: false,
        // addOrUpdateVisible: false,
        // url:"",
        // dialogVisible:"false",
      dataForm: {
        id: '',
        advertPlatformAccountId: '',
        accountName: '',
        advertPlatform: null,
        status: '',
        accessToken: '',
        refreshToken: '',
        accessTokenExpiresIn: '',
        refreshTokenExpiresIn: '',
        accessTokenExpireTime: '',
        refreshTokenExpireTime: '',
        authorizerInfo: '',
        createdBy: '',
        updatedBy: '',
        createTime: '',
        updateTime: '',
        deleteTime: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        advertPlatformAccountId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        accountName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        advertPlatform: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        status: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        accessToken: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        refreshToken: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        accessTokenExpiresIn: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        refreshTokenExpiresIn: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        accessTokenExpireTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        refreshTokenExpireTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        authorizerInfo: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        createdBy: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        updatedBy: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        createTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        updateTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        deleteTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/sys/advertoauth/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
      operateOauth (id) {
      

      },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http[!this.dataForm.id ? 'post' : 'put']('/sys/advertoauth/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
            this.url=res.data;
            // this.addOrUpdateVisible = true
            // this.$nextTick(() => {
            //     this.$refs.operateOauth.dataForm.url = this.url;
            //     this.$refs.operateOauth.init()
            // })
            window.location.href = this.url
          /*this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              /!*this.visible = false
              this.$emit('refreshDataList')*!/
                window.location.href = this.url
            }
          })*/
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }/*,
    components: {
        OperateAuth
    }*/
}
</script>
